export const isValidAmountParam = (amt?: string) => {
  if (!amt) {
    return false;
  }

  if (typeof amt !== 'string') {
    return false;
  }
  const trimmed = amt.trim();
  if (!trimmed) {
    return false;
  }
  const parsed = parseFloat(trimmed);
  return !isNaN(parsed) && isFinite(parsed) && parsed >= 0;
};
